export enum ErrorType {
    standardFormlyError = 'standardFormlyError',
    bussinessValidationError = 'bussinessValidationError',
    lookupFormlyError = 'lookupFormlyError',
    errorInactive = 'errorInactive' // error no active
}